import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: { width: '100%' },
    container: {
        maxHeight: '570px',
    },
    newContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '12px',
        width: '100%',
    },
    containerDesktop: {
        maxHeight: '560px',
    },
    gridContainer: {
        '& div': {
            maxWidth: 'inherit',
            padding: '8px',
        },
    },
    btn: {
        '& .MuiButton-label': {
            fontSize: 14,
        },
        '& .MuiButton-contained': {
            background: '#fff',
        },
    },
    btnFilter: {
        alignItems: 'flex-end',
        display: 'flex',
        justifyContent: 'center',
        margin: '8px 8px 0px 8px',

        '&:disabled': {
            backgroundColor: '#F6F6F6',
            color: '#8181A5',
        },
    },
    filterInput: {
        backgroundColor: '#fff',
        borderRadius: 8,
        boxShadow:
            '0px 0px 2px rgba(52, 58, 67, 0.1), 0px 1px 2px rgba(52, 58, 67, 0.08), 0px 1px 4px rgba(52, 58, 67, 0.08)',
        color: '#53627C',
        height: 42,
        padding: '14px 16px',
        width: '100%',
    },
    mobileRoot: {
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        paddingBottom: 100,
    },
    mobileHeader: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #e0e0e0',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        paddingTop: theme.spacing(2),
    },
    mobileHeaderContent: {
        padding: theme.spacing(2),
    },
    mobileSearchBox: {
        marginBottom: theme.spacing(2),
    },
    mobileButtonGroup: {
        display: 'flex',
        gap: theme.spacing(1),
        flexDirection: 'column',
    },
    mobileClientList: {
        padding: theme.spacing(0, 2, 2, 2),
        marginTop: theme.spacing(2),
    },
    mobileStatsSection: {
        marginBottom: theme.spacing(3),
        width: '100%',
    },
    mobileStatsTitle: {
        fontSize: 18,
        fontWeight: 600,
        color: '#292524',
        marginBottom: theme.spacing(2),
    },
    mobileStatsGridSingle: {
        display: 'flex',
        width: '100%',
    },
    mobileStatsCard: {
        flex: 1,
        minWidth: 0,
        borderRadius: 12,
        padding: theme.spacing(2),
        textAlign: 'center',
        boxSizing: 'border-box',
    },
    mobileStatsCardSage: {
        backgroundColor: '#f4f7f5',
        border: '1px solid #c5d4c9',
    },
    mobileStatsCardValue: {
        fontSize: 24,
        fontWeight: 700,
        lineHeight: 1.2,
        marginBottom: 4,
    },
    mobileStatsCardValueSage: { color: '#3f5239' },
    mobileStatsCardLabel: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.3,
    },
    mobileStatsCardLabelSage: { color: '#4d5c4f' },
    mobileClientCardShell: {
        marginBottom: theme.spacing(2),
        backgroundColor: '#fff',
        borderRadius: 12,
        border: '1px solid #e7e5e4',
        padding: theme.spacing(2),
        boxShadow: 'none',
    },
    mobileClientCardRow: {
        display: 'flex',
        alignItems: 'flex-start',
    },
    mobileClientAvatar: {
        width: 48,
        height: 48,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginRight: theme.spacing(1.5),
        '& svg': {
            fontSize: 24,
        },
    },
    mobileClientMainCol: {
        flex: 1,
        minWidth: 0,
    },
    mobileClientTopRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),
    },
    mobileClientTextBlock: {
        minWidth: 0,
        paddingRight: theme.spacing(1),
    },
    mobileClientNameLink: {
        fontSize: 14,
        fontWeight: 600,
        color: '#292524',
        textDecoration: 'none',
        display: 'block',
        lineHeight: 1.35,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    mobileClientSubline: {
        fontSize: 12,
        color: '#78716c',
        marginTop: 2,
        display: 'block',
        lineHeight: 1.4,
        wordBreak: 'break-word',
    },
    mobileClientActions: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'flex-start',
        '& > *:not(:last-child)': {
            marginRight: 4,
        },
    },
    mobileClientActionPhone: {
        width: 28,
        height: 28,
        padding: 0,
        borderRadius: '0.5rem',
        backgroundColor: '#dbeafe',
        '&:hover': {
            backgroundColor: '#bfdbfe',
        },
    },
    mobileClientActionWhatsapp: {
        width: 28,
        height: 28,
        padding: 0,
        borderRadius: '0.5rem',
        backgroundColor: '#dcfce7',
        '&:hover': {
            backgroundColor: '#bbf7d0',
        },
    },
    mobileClientOrdersLine: {
        fontSize: 12,
        fontWeight: 400,
        color: '#44403c',
        lineHeight: 1.35,
        flex: 1,
        minWidth: 0,
        marginRight: theme.spacing(1),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    mobileClientOrdersLineBold: {
        fontWeight: 700,
    },
    mobileClientCardFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        width: '100%',
        marginTop: 0,
        gap: theme.spacing(1),
    },
    mobileClientVerBtn: {
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.8125rem',
        minHeight: 32,
        padding: '4px 12px',
        lineHeight: 1.2,
        borderRadius: '0.5rem',
        flexShrink: 0,
    },
    mobilePaginationSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        width: '100%',
    },
    mobilePaginationSummary: {
        fontSize: 13,
        lineHeight: 1.5,
        color: '#57534e',
        textAlign: 'center',
        marginBottom: theme.spacing(1.5),
        fontWeight: 500,
    },
    mobilePaginationBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
        gap: theme.spacing(0.5),
        backgroundColor: '#fff',
        borderRadius: 12,
        border: '1px solid #e7e5e4',
        padding: theme.spacing(2),
        width: '100%',
        boxSizing: 'border-box',
    },
    mobilePaginationPrevNext: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        padding: '6px 8px',
        fontSize: 13,
        fontWeight: 500,
        fontFamily: 'inherit',
        lineHeight: 1.25,
        color: '#57534e',
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: 8,
        cursor: 'pointer',
        transition: 'color 0.15s ease, background-color 0.15s ease',
        '&:hover:not(:disabled)': {
            color: '#292524',
        },
        '&:focus': {
            outline: 'none',
        },
        '&:focus-visible': {
            boxShadow: '0 0 0 2px rgba(109, 144, 128, 0.55)',
        },
        '&:disabled': {
            opacity: 0.38,
            cursor: 'default',
        },
    },
    mobilePaginationPrevNextIcon: {
        fontSize: 18,
        width: 18,
        height: 18,
    },
    mobilePaginationPrevNextIconBefore: {
        marginRight: 8,
    },
    mobilePaginationPrevNextIconAfter: {
        marginLeft: 8,
    },
    mobilePaginationPages: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        gap: 4,
        flex: '1 1 auto',
        minWidth: 0,
        maxWidth: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    mobilePaginationPageBtn: {
        width: 28,
        height: 28,
        minWidth: 28,
        flexShrink: 0,
        padding: 0,
        fontSize: 13,
        fontWeight: 500,
        fontFamily: 'inherit',
        lineHeight: 1,
        color: '#57534e',
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: 8,
        cursor: 'pointer',
        transition: 'background-color 0.15s ease, color 0.15s ease',
        '&:hover': {
            backgroundColor: '#f5f5f4',
        },
        '&:focus': {
            outline: 'none',
        },
        '&:focus-visible': {
            boxShadow: '0 0 0 2px rgba(109, 144, 128, 0.55)',
        },
    },
    mobilePaginationPageBtnActive: {
        backgroundColor: '#6d9080',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#5f7f72',
            color: '#fff',
        },
    },
    mobilePaginationEllipsis: {
        fontSize: 13,
        color: '#a8a29e',
        padding: '0 1px',
        flexShrink: 0,
        userSelect: 'none',
        whiteSpace: 'nowrap',
    },
    mobilePaginationMeta: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0, 0.5),
    },
    mobilePaginationSelectLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: '#57534e',
        marginBottom: theme.spacing(0.75),
        marginTop: theme.spacing(0.5),
        display: 'block',
    },
    mobilePaginationSelect: {
        width: '100%',
        padding: theme.spacing(1.75, 1.5),
        fontSize: 16,
        lineHeight: 1.25,
        borderRadius: 10,
        border: '1px solid #d6d3d1',
        backgroundColor: '#fff',
        color: '#292524',
        WebkitAppearance: 'none',
        appearance: 'none',
        backgroundImage:
            'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 24 24\' fill=\'%2357534e\'%3E%3Cpath d=\'M7 10l5 5 5-5z\'/%3E%3C/svg%3E")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 12px center',
        paddingRight: 36,
    },
}));

export default useStyles;